import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center animate-fade-in" data-testid="not-found-page">
      <Compass size={40} className="text-cyan-700 mb-4" strokeWidth={1.5} />
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Page not found</h1>
      <p className="text-slate-500 mt-2 max-w-sm">The page you're looking for doesn't exist or has moved.</p>
      <Button asChild className="mt-6 rounded-sm" data-testid="not-found-home-btn"><Link to="/dashboard">Back to dashboard</Link></Button>
    </div>
  );
}
